import { render, staticRenderFns } from "./configSeting.vue?vue&type=template&id=06951110&scoped=true&"
import script from "./configSeting.vue?vue&type=script&lang=js&"
export * from "./configSeting.vue?vue&type=script&lang=js&"
import style0 from "./configSeting.vue?vue&type=style&index=0&id=06951110&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06951110",
  null
  
)

export default component.exports